module.exports = __webpack_public_path__ + "static/media/present.a417ab28.svg";